import { styled } from '@mui/material';
import { getRGBA } from '../../../utils/getRGBA/getRGBA.js';

const DAY_SIZE = 32;
const DatePickerDayStyles = styled("div")(({ theme }) => ({
    ".react-datepicker__day": Object.assign(Object.assign({ display: "flex", width: DAY_SIZE, height: DAY_SIZE, backgroundColor: theme.palette.ui20, color: theme.palette.text.greyMedium, justifyContent: "center", alignItems: "center", padding: theme.spacing(1, 1.5) }, theme.typography.tinyBold), { "&:not(&--disabled)": {
            cursor: "pointer",
        }, "&:focus, &:focus-visible": {
            outline: "none",
        }, "&--in-selecting-range:not(&--outside-month, &--selecting-range-start, &--selecting-range-end), &--in-range:not(&--outside-month, &--range-start, &--range-end)": {
            backgroundColor: getRGBA(theme.palette.primary.main, 0.05),
        }, "&--today:not(&--outside-month, &--range-start, &--range-end, &--selected)": {
            color: theme.palette.text.highlight,
        }, "&:hover:not(&--outside-month, &--disabled, &--range-start, &--range-end, &--selecting-range-start, &--selected)": {
            backgroundColor: getRGBA(theme.palette.primary.main, 0.15),
        }, "&:active:not(&--outside-month, &--disabled, &--range-start, &--range-end, &--selecting-range-start, &--selected)": {
            backgroundColor: getRGBA(theme.palette.primary.main, 0.2),
        }, "&--keyboard-selected:not(&--outside-month, &--disabled, &--range-start, &--range-end, &--selecting-range-start, &--selected)": {
            "&:focus-within": {
                border: `1px solid ${theme.palette.primary.main}`,
                backgroundColor: getRGBA(theme.palette.primary.main, 0.15),
            },
        }, "&--selected:not(&--outside-month), &--range-start:not(&--outside-month), &--selecting-range-start:not(&--outside-month), &--range-end:not(&--outside-month)": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.text.white,
            "&:hover": {
                boxShadow: `
          0px 1px 2px 0px ${getRGBA(theme.palette.primary.main, 0.25)},
          0px 2px 8px 0px rgba(32, 37, 43, 0.10)
          `,
            },
            "&:active": {
                boxShadow: "none",
            },
            "&:focus-within": {
                border: `1px solid ${theme.palette.primary[400]}`,
                backgroundColor: theme.palette.primary.main,
            },
        }, "&--range-start, &--selecting-range-start": {
            borderTopLeftRadius: theme.spacing(0.5),
            borderBottomLeftRadius: theme.spacing(0.5),
        }, "&--range-end, &--selecting-range-end": {
            borderTopRightRadius: theme.spacing(0.5),
            borderBottomRightRadius: theme.spacing(0.5),
        }, "&--selected": {
            borderRadius: theme.spacing(0.5),
        }, "&--outside-month": {
            pointerEvents: "none",
            "& > span": {
                display: "none",
            },
        }, "&--disabled": {
            color: theme.palette.ui60,
            overflow: "hidden",
            cursor: "not-allowed",
        } }),
}));

export { DAY_SIZE, DatePickerDayStyles };
//# sourceMappingURL=Day.js.map
